import { Component, Input, OnChanges } from '@angular/core';

import { environment } from '../../../environments/environment';
import { SearchResultApp, SearchResultCategory, SearchResultPage, SearchResults, SearchSnippetPart } from '../../helpers/search';

import { DocsService } from '../../services/docs.service';

@Component({
    selector: 'kd-search-results',
    templateUrl: './search-results.component.html',
    styleUrls: ['./search-results.component.scss']
})
export class SearchResultsComponent implements OnChanges {

    @Input()
    results: SearchResults;

    displayCategory: boolean = environment.searchCategories;
    private snippets: Array<Array<Array<Array<SearchSnippetPart>>>>;

    constructor(
        private docsService: DocsService,
    ) { }

    ngOnChanges() {
        if (this.results && this.results.results) {
            this.init();
        } else {
            this.snippets = [];
        }
    }

    getSnippet(appIndex: number, categoryIndex: number, pageIndex: number): Array<SearchSnippetPart> {
        return this.snippets[appIndex][categoryIndex][pageIndex];
    }

    private init(): void {
        this.snippets = this.results.results.map((appResult: SearchResultApp): Array<Array<Array<SearchSnippetPart>>> => {
            return appResult.categories.map((categoryResult: SearchResultCategory): Array<Array<SearchSnippetPart>> => {
                return categoryResult.pages.map((pageResult: SearchResultPage): Array<SearchSnippetPart> => {
                    const parts: Array<SearchSnippetPart> = this.docsService.parseSearchSnippet(pageResult.snippet, this.results.query);
                    return parts;
                });
            });
        });
    }

    trackByIndex(index: number): number {
        return index;
    }
}
